const { RichText } = wp.blockEditor;

const Save = ({ attributes }) => {
  const {
    title,
    image,
    icon,
    button,
    description,
    subDescription,
    hrefLink,
    margin,
  } = attributes;

  return (
    <section className={`SectionMap ${margin}`}>
      <div className="Container">
        <RichText.Content
          tagName="h2"
          value={title}
          className="Typography title-4 left margin-medium color-blue-dark"
        />

        <RichText.Content
          tagName="p"
          value={description}
          className="Typography text left margin-base color-grey"
        />

        <div className="SectionMap-sep margin-base">
          <figure className="SectionMap-image">
            <img
              src={image.src}
              title={image.alt}
              width={image.width}
              height={image.height}
              alt={image.alt}
              class="SectionMap-image"
            />
          </figure>
        </div>

        <RichText.Content
          tagName="p"
          value={subDescription}
          className="Typography text left margin-base color-grey"
        />

        <a title="Button" href={hrefLink} className="Button ButtonPlans">
          <div>
            <figure className="SectionMap-icon">
              <img
                src={icon.src}
                title={icon.alt}
                width={icon.width}
                height={icon.height}
                alt={icon.alt}
                class="SectionMap-icon"
              />
            </figure>
          </div>

          <RichText.Content tagName="p" value={button} />
        </a>
      </div>
    </section>
  );
};

export default Save;
